/* src/store.js
   Zentrale Redux-Store-Konfiguration (Minimal-Setup für die App).
   Kann später um Slices/Reducer erweitert werden. */

import { configureStore } from "@reduxjs/toolkit";

function runtimeReducer(state = {}) {
  return state;
}

export const store = configureStore({
  reducer: {
    runtime: runtimeReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
});
